export default "__VITE_ASSET__DpGU9gTh__"